module.exports = __webpack_public_path__ + "media/application/images/icons/tooltip_triangle-b20e717f8ba2a1755ade3b30ab11487a.svg";